import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { AuditLogEventName } from 'pages/AuditLogPage/AuditLogViewPage/styles';
import { IAuditLogItemResponse } from 'models/auditLog';
import { DetailsTemplate, EDetailsPageTypes } from 'components/templates/DetailsTemplate';
import Grid from '@mui/material/Grid';
import { useTranslations } from 'hooks/useTranslations';

interface IAdministrationPasswordChange {
  auditLog: IAuditLogItemResponse;
}

const AdministrationPasswordChange = ({ auditLog }: IAdministrationPasswordChange) => {
  const [details, setDetails] = useState<any | null>();
  const { t } = useTranslations();

  useEffect(() => {
    if (auditLog?.postObjectValue) {
      (async () => {
        const postObjectValue = auditLog?.postObjectValue as any;
        const postData = {
          firstName: postObjectValue.firstName,
          lastName: postObjectValue.lastName,
          email: postObjectValue.email,
          eventName: auditLog.eventName || '',
          type: auditLog.eventType,
        };
        setDetails(postData);
      })();
    }
  }, [auditLog]);

  if (details) {
    return (
      <>
        <AuditLogEventName sx={{ marginTop: '20px' }}>
          <Typography variant="h5">{details.type}</Typography>
        </AuditLogEventName>
        <DetailsTemplate
          pageType={EDetailsPageTypes.auditLogView}
          title={details.eventName}
          disableActions={true}
        >
          <Grid size={{ xs: 12 }} container>
            {details.firstName && (
              <Grid size={{ xs: 3 }}>
                <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                  {t('users.firstName.label')}
                </Typography>
                <Typography variant="body2">{details.firstName}</Typography>
              </Grid>
            )}
            {details.lastName && (
              <Grid size={{ xs: 3 }}>
                <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                  {t('users.lastName.label')}
                </Typography>
                <Typography variant="body2">{details.lastName}</Typography>
              </Grid>
            )}
            {details.email && (
              <Grid size={{ xs: 3 }}>
                <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                  {t('users.email.label')}
                </Typography>
                <Typography variant="body2">{details.email}</Typography>
              </Grid>
            )}
          </Grid>
        </DetailsTemplate>
      </>
    );
  }
  return <>-</>;
};

export default AdministrationPasswordChange;
